<template>
  <div>

    <!-- Exibe a lista de produtos -->
    <div :class="isInputError('products')" @click="removeError('products')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">{{ $t('views.seller.integrations.config.save.product.title') }}</strong>
        <a href="#" @click.prevent="selectAll('products')" class="select-all float-right">
          {{ products?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="products.value"
        :options="products.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :limit-text="limitText" 
        :limit="4" 
        :searchable="true"
        :loading="loadingProducts"
        :group-select="true"
        :select-label="'Select'"
        :disabled="loading"
        class="new-style"
        group-values="options"
        group-label="group"
        :placeholder="$t('views.seller.integrations.config.save.product.search')" 
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="option__title" v-if="props.option?.$isLabel">
            {{ props.option.$groupLabel.name }}
            <span class="label-info label-info--deselected">{{ $t('views.seller.integrations.config.save.product.select_all') }}</span>
            <span class="label-info label-info--selected">{{ $t('views.seller.integrations.config.save.product.remove_all') }}</span>
          </span>
          <span class="d-flex option__item" v-else>
            <img :src="isOptionSelected('products', props.option.id)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">{{ $t('views.seller.integrations.config.save.product.select') }}</span>
        </template>
        <span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
        <span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
        <div slot="limit" class="multiselect__tag limit">+{{ products?.value?.length - 4 }}</div>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('products') }}</span>
    </div>

    <!-- Exibe URL -->
    <div :class="isInputError('url')" @click="removeError('url')">
      <strong class="title-medium mt-4">{{ $t('views.seller.integrations.config.save.url.title') }}</strong>
      <b-form-group id="fieldset-url" label-for="input-url">
        <b-form-input id="input-url" :placeholder="`Informe a URL do ${integration.name}`" class="form-input" v-model="url" :disabled="loading" trim></b-form-input>
      </b-form-group>
      <span class="show-error">
        {{ showError('url') }}
        <template v-if="sugestionRedirect.url">
          <br />
          {{ $t('views.seller.integrations.config.save.url.sugestion_1') }}
          {{ sugestionRedirect.name }}
          {{ $t('views.seller.integrations.config.save.url.sugestion_2') }}
          <a :href="`/integracoes/${sugestionRedirect.url}`" @click.stop>
            {{ $t('views.seller.integrations.config.save.url.sugestion_3') }}
            {{ sugestionRedirect.name }}.
          </a>
        </template>
      </span>
    </div>

    <!-- Botao Salvar -->
    <b-button class="btn-confirm mt-4" variant="primary" :disabled="loading || loadingSave" @click="saveCallbacks">
      <template v-if="loadingSave">
        <b-spinner variant="light" class="mr-2" small></b-spinner>
        {{ $t('views.seller.integrations.config.save.button.saving') }}
      </template>
      <template v-else>
        {{ $t('views.seller.integrations.config.save.button.save') }}
      </template>
    </b-button>

  </div>
</template>

<script>

import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import CallbackService from '@/services/resources/CallbackService';

export default {
  name: "IntegrationsConfigTheMembers",
  components: {
    Multiselect
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    loadingProducts: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'The Members' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    sugestionRedirect: {
      type: Object,
      required: true,
      default: () => ({
        url: null,
        name: null,
      })
    },
    removeError: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    selectAll: {
      type: Function,
      required: true
    },
    isOptionSelected: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
    updateCallbacks: {
      type: Function,
      required: true
    }
  },
  data: () => {
    return {
      url: '',
      loadingSave: false,
    }
  },
  methods: {
    resetForm() {
      this.url = '';
      this.products.value = null;
    },
    saveCallbacks() {
      
      this.loadingSave = true;

      const products = this.products?.value?.map(product => product.id) || [];
      const events = [
        { trigger: 'salePaid' },
        { trigger: 'saleRefunded' },
        { trigger: 'saleChargedback' },
        { trigger: 'contractTrialing' },
        { trigger: 'contractPaid' },
        { trigger: 'contractEnded' },
        { trigger: 'contractCanceled' }
      ];
      const url = this.url;

      CallbackService.build().create({
        url,
        products,
        events
      }, null, `integrations/group/${this.integration.id}`, { suppressErrorNotify: true })
      .then(() => {
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.success.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

        this.resetForm();
        this.fetchCallbacks();
      })
      .catch(err => {
        console.log(err)
        this.mountInputError(err.response.data);
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
      .finally(() => {
        this.loadingSave = false;
      });
    }
  }
}

</script>
